import { request } from '../client'
import type {
  SkinClashCurrentResponse,
  SkinClashHistoryResponse,
  SkinClashJoinRequest,
  SkinClashJoinResponse,
} from '@/services/models/skinClash'

export async function getSkinClashCurrent() {
  return request<SkinClashCurrentResponse>({
    method: 'GET',
    url: '/v1/skin-clash/current',
    skipAuth: true,
  })
}

export async function getSkinClashHistory() {
  return request<SkinClashHistoryResponse>({
    method: 'GET',
    url: '/v1/skin-clash/history',
    skipAuth: true,
  })
}

export async function postSkinClashJoin(data: SkinClashJoinRequest) {
  return request<SkinClashJoinResponse>({
    method: 'POST',
    url: '/v1/skin-clash/join',
    data,
  })
}
